const scrollToElement = (eleId) => {
	const ele = document.getElementById(eleId);
	if (!ele) return;
	requestAnimationFrame(() => {
		ele.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	});
};

export default scrollToElement;
